/**
*
* Wrapper
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import loadable from '@loadable/component';

import WrapperBase from './WrapperBase';

const WrapperWithConnect = loadable(() => import('./WrapperWithConnect'));

function Wrapper(props) {

  if (props.isEditor) {
    return <WrapperWithConnect {...props} />
  }
  return <WrapperBase {...props} />
}

Wrapper.propTypes = {
  isEditor: PropTypes.bool,
  typeOfStyle: PropTypes.string,
  viewPort: PropTypes.string,
  type: PropTypes.string,
  streams: PropTypes.array,
  pages: PropTypes.array,
  pageIdLinked: PropTypes.string,
  sectionIdLinked: PropTypes.string,
  styling: PropTypes.object,
  editorData: PropTypes.object,
  openEditor: PropTypes.func,
  helpers: PropTypes.object,
  language: PropTypes.string,
  video: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  content: PropTypes.object,
  formData: PropTypes.object,
  handleFormChange: PropTypes.func,
  handleClick: PropTypes.func,
  baseUrlTamplate: PropTypes.string,
  selectData: PropTypes.object,
  defaultUrl: PropTypes.string,
  clickValue: PropTypes.string,
  stream: PropTypes.string,
  formState: PropTypes.object,
  selectValue: PropTypes.string,
  handleSelectChange: PropTypes.func,
  as: PropTypes.string,
  defaultValues: PropTypes.object,
  backgroundImage: PropTypes.string,
  href: PropTypes.string,
  innerRef: PropTypes.object,
  viewRef: PropTypes.string,
  isCurrent: PropTypes.bool,
  target: PropTypes.string
};




export default Wrapper;
